import { Typography } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import { Color, Inline, Stack, Tag } from '@superdispatch/ui';
import { ResponsiveTooltip } from 'shared/ui/ResponsiveTooltip';
import styled from 'styled-components';

const TooltipTitle = styled(Typography)`
  color: ${Color.Yellow300};
`;

interface PostingShipperUnverifiedBadgeProps {
  externalNotes: string | null;
}

export function PostingShipperUnverifiedBadge({
  externalNotes,
}: PostingShipperUnverifiedBadgeProps) {
  return (
    <Inline
      aria-label="unverified shipper"
      verticalAlign="center"
      space="xxsmall"
    >
      <Tag color="red" variant="subtle">
        Unverified
      </Tag>
      <ResponsiveTooltip
        title={
          <Stack space="xxsmall">
            <TooltipTitle>This Shipper is Unverified</TooltipTitle>
            <Stack space="medium">
              <Typography>
                This Shipper is not verified on Super Dispatch. We recommend
                taking additional steps to vet the Shipper&apos;s legal
                documents.
              </Typography>
              {externalNotes && (
                <Stack space="none">
                  <Typography>Notes:</Typography>
                  <Typography>{externalNotes}</Typography>
                </Stack>
              )}
            </Stack>
          </Stack>
        }
      >
        <Info
          aria-label="unverified shipper details"
          fontSize="small"
          color="action"
        />
      </ResponsiveTooltip>
    </Inline>
  );
}
